// copied from https://gist.github.com/rmorse/426ffcc579922a82749934826fa9f743
import { useContext, useEffect, useCallback } from 'react'
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom'

export function useBlocker(blocker: (tx: any) => void, when: boolean = true) {
  const { navigator } = useContext(NavigationContext)

  useEffect(() => {
    if (!when) {
      return
    }

    // @ts-ignore
    const unblock = navigator.block((tx: any) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock()
          tx.retry()
        },
      }

      blocker(autoUnblockingTx)
    })

    return unblock
  }, [navigator, blocker, when])
}

export function usePrompt(message: string, when: boolean = true) {
  const blocker = useCallback(
    (tx: any) => {
      if (window.confirm(message)) {
        tx.retry()
      }
    },
    [message]
  )

  useBlocker(blocker, when)
}
